export default "__VITE_ASSET__Dse7pJvp__"